import { render, staticRenderFns } from "./hero-item.vue?vue&type=template&id=10a665ec&scoped=true&"
import script from "./hero-item.vue?vue&type=script&lang=js&"
export * from "./hero-item.vue?vue&type=script&lang=js&"
import style0 from "./hero-item.vue?vue&type=style&index=0&id=10a665ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a665ec",
  null
  
)

export default component.exports